import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module'
import { AuthGuard } from '../auth-guard.service';
import { DriversclubComponent } from './driversclub.component';
import { MyBusinessAdvantageComponent } from './mybusinessadvantage.component';
import { MyFleetSolutionsComponent } from './myfleetsolutions.component';
import { ApplyNowComponent } from './applynow.component';
import { MyFuelCardAccount } from './myfuelcardaccount.component';
import { WidgetComponent } from './widget.component';
import { BlogDetailComponent } from './blogdetail.component';
import { RelatedNewsComponent } from './relatednews.component';
import { OfferDetailComponent } from './offerdetail.component';
import { RelatedOffersComponent } from './relatedoffers.component';
import { RssNewsFeedDetailsComponent } from '../home/rssnewsfeeddetails.component';
import { DriversClubNewsDetailComponent } from './driversclubnewsdetail.componen';
import { RelatedDriversClubNewsComponent } from './relateddriversclubnews.component';
import { Myfleetsolutionsv2Component } from './myfleetsolutionsv2/myfleetsolutionsv2.component';
import { MailSurveyComponent } from './mailsurvey/mailsurvey.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: 'survey/mailsurvey', component: MailSurveyComponent },
      { path: 'Survey/MailSurvey', component: MailSurveyComponent },
      { path: 'driversclub', component: DriversclubComponent },
      { path: 'mybusinessadvantage', component: MyBusinessAdvantageComponent },
      //{ path: 'myfleetsolutions', component: MyFleetSolutionsComponent },
      { path: 'myfleetsolutions', component: Myfleetsolutionsv2Component },
      { path: 'myfuelcardaccount', component: MyFuelCardAccount },
      { path: 'blog/:slug', component: BlogDetailComponent },
      { path: 'blog/:slug/:category', component: BlogDetailComponent },
      { path: 'offer/:slug', component: OfferDetailComponent },
      { path: 'offer/:slug/:category', component: OfferDetailComponent },
      { path: 'driverscluboffer/:slug', component: DriversClubNewsDetailComponent }
    ]),

  ],
  exports: [

  ],
  declarations: [
    MailSurveyComponent,
    DriversclubComponent,
    MyBusinessAdvantageComponent,
    MyFleetSolutionsComponent,
    ApplyNowComponent,
    MyFuelCardAccount,
    WidgetComponent,
    BlogDetailComponent,
    RelatedNewsComponent,
    OfferDetailComponent,
    RelatedOffersComponent,
    DriversClubNewsDetailComponent,
    RelatedDriversClubNewsComponent,
    Myfleetsolutionsv2Component
  ],
  providers: [

  ]
})
export class GenericModule { }



// WEBPACK FOOTER //
// ./src/app/genericpages/generic.module.ts